import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {DialogComponent} from './dialog.component';
import {MatDialogModule} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import {MaterialModule} from '../../material.module';
import {InfraModule} from 'ac-infra';

@NgModule({
  declarations: [
    DialogComponent
  ],
    imports: [
        CommonModule,
        MatDialogModule,
        MatButtonModule,
        MaterialModule,
        InfraModule
    ],
  exports: [
    DialogComponent
  ]
})
export class DialogModule { }
